import * as React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Colors from '@ziynx/theme/colors';
import { SubHeading } from '@krispy/typography/web';
import * as KrispyTokens from '@krispy-tokens/blue';

const propTypes = {
  label: PropTypes.string,
  variant: PropTypes.oneOf(['gray', 'green']),
};
const defaultProps = {
  variant: 'gray',
};

const StyledTag = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
  width: fit-content;
  max-width: 120px;
  border-radius: 4px;
  background-color: ${({ variant }) => (variant === 'green' ? Colors.SecondaryGreen : Colors.GrayVeryLight)};
`;

const StyledSubHeading = styled(SubHeading)`
  padding: 0 ${KrispyTokens.KrispySpacingElementsHdMedium}px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ variant }) => (variant === 'green' ? Colors.White : Colors.GrayDark)};
`;

const Tag = (props) => {
  const {
    label,
    variant,
  } = props;

  return (
    <>
      <StyledTag variant={variant}>
        <StyledSubHeading variant={variant}>{label}</StyledSubHeading>
      </StyledTag>
    </>
  );
};

Tag.propTypes = propTypes;
Tag.defaultProps = defaultProps;

export default Tag;
